/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_cards_controls_freeze = /** @type {(inputs: {}) => string} */ () => {
	return `Congelar Tarjeta`
};

const en_cards_controls_freeze = /** @type {(inputs: {}) => string} */ () => {
	return `Freeze Card`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cards_controls_freeze = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cards_controls_freeze(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cards_controls_freeze", locale)
	if (locale === "es") return es_cards_controls_freeze(inputs)
	return en_cards_controls_freeze(inputs)
};
export { cards_controls_freeze as "cards.controls.freeze" }